import type { ComponentTemplate } from "schemas/generated/componentTemplates";

import { transformReviewsTemplateToUseProductForContextIfNecessary } from "./defaultComponentTemplate";

export const feraStoreReviewsWidget: ComponentTemplate = {
  id: "ebdbf4e5-ca60-4906-a2b8-a5b108de4b58",
  storeId: null,

  scope: "left-bar",
  type: "component",
  name: "Product/Fera Store Reviews",
  leftBarCategory: { main: "productIntegrations", subCategory: "fera" },
  tags: ["product", "widget"],
  preview: "integrations/fera-store-reviews.svg",
  transforms: [transformReviewsTemplateToUseProductForContextIfNecessary],
  template: {
    id: "$uid",
    type: "feraStoreReviewsWidget",
    props: { style: { alignSelf: "stretch" } },
  },
};
